import { createSelector } from 'reselect';

const selectScribeSession = state => state.scribeSession;

export const selectUser = createSelector([selectScribeSession], scribeSession => scribeSession.captioner);

export const selectUserFeatures = createSelector([selectUser], user => user.features);
